import React from 'react'

import Modal from 'react-modal'
import { Link } from 'react-router-dom'

import axios from 'axios'
import PropTypes from 'prop-types'

import moment from 'moment'

import withRouter from 'Pods/Shared/withRouter'

import Icon from '../../../Shared/Icon/Icon'
import Loader from '../../../Shared/Loader'
import SocialButtons from '../../../Shared/SocialButtons'
import Tooltip from '../../../Shared/Tooltip'

class ModalPreview extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isLoaded: false,
      item: {},
      included: [],
      previous: 0,
      next: 0,
      previousSlug: '',
      nextSlug: '',
      path: '',
    }

    this.closeModal = this.closeModal.bind(this)
    this.onFetchSuccess = this.onFetchSuccess.bind(this)
    this.like = this.like.bind(this)
    this.onLikeSuccess = this.onLikeSuccess.bind(this)
    this.handleKeyDown = this.handleKeyDown.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    this.fetchEntries(nextProps.match.params.id)
  }

  componentDidMount() {
    this.cancelSource = axios.CancelToken.source()

    this.fetchEntries(this.props.match.params.id)

    this.checkPath()

    document.addEventListener('keydown', this.handleKeyDown)
  }

  componentWillUnmount() {
    this.cancelSource.cancel()

    document.removeEventListener('keydown', this.handleKeyDown)
  }

  fetchEntries(id) {
    axios.get(`/api/internal/${this.props.competitionSlug}/competition-submissions/${id}`,
      { cancelToken: this.cancelSource.token })
      .then(this.onFetchSuccess)
      .catch(this.onFetchEntriesFailure)
  }

  onFetchSuccess(response) {
    this.setState({
      isLoaded: true,
      item: response.data.data,
      included: response.data.included,
    })

    this.updateNextPositions()
  }

  updateNextPositions() {
    const order = this.props.galleryOrder
    const slugs = this.props.gallerySlugs
    const position = order.indexOf(this.state.item.id)

    this.setState({
      previous: position === 0 ? 0 : order[position - 1],
      next: position === (order.length - 1) ? 0 : order[position + 1],
      previousSlug: position === 0 ? '' : slugs[position - 1],
      nextSlug: position === (order.length - 1) ? '' : slugs[position + 1],
    })
  }

  checkPath() {
    this.setState({
      path: this.props.location.pathname.indexOf('gallery') > -1 ? '/gallery' : '',
    })
  }

  closeModal() {
    this.props.history.push(`/${this.props.competitionSlug}${this.state.path}`)
  }

  like() {
    axios.post('/api/internal/likes/like', {
      like: {
        likeable_id: this.state.item.id,
        likeable_type: 'CompetitionSubmission',
      },
    }).then(this.onLikeSuccess).catch((error) => {})
  }

  onLikeSuccess(response) {
    return this.setState(prevState => ({
      item: {
        ...prevState.item,
        attributes: {
          ...prevState.item.attributes,
          likesCount: response.data.count,
          likeState: response.data.status === 'liked',
        },
      },
    }))
  }

  handleKeyDown(e) {
    if (e.keyCode == 37) {
      if (this.state.previous > 0) {
        this.props.history.push(
          `/${this.props.competitionSlug}${this.state.path}/${this.state.previous}/${this.state.previousSlug}`
        )
      }
    }
    if (e.keyCode == 39) {
      if (this.state.next > 0) {
        this.props.history.push(
          `/${this.props.competitionSlug}${this.state.path}/${this.state.next}/${this.state.nextSlug}`
        )
      }
    }
  }

  render() {
    const item = this.state.item

    const imagesList = this.state.included.filter((included) => included.type === 'competitionImages')

    return (
      <Modal
        isOpen
        shouldCloseOnOverlayClick
        onRequestClose={this.closeModal}
        contentLabel="Modal"
        ariaHideApp={false}
        className={{
          base: 'overlay-modal--container',
          afterOpen: 'overlay-modal--container_after-open',
          beforeClose: 'overlay-modal--container_before-close',
        }}
        overlayClassName={{
          base: 'overlay-modal--background',
          afterOpen: 'overlay-modal--background_after-open',
          beforeClose: 'overlay-modal--background_before-close',
        }}
      >
        <div className="preview-modal">
          {this.state.previous > 0
          && (
          <Link
            to={{ pathname: `/${this.props.competitionSlug}${this.state.path}/${this.state.previous}/${this.state.previousSlug}` }}
            params={{ competitionSlug: this.props.competitionSlug }}
            className="preview-modal--previous"
          >
            <Icon type="chevron-left" color="grey-dark" />
          </Link>
          )
          }

          {this.state.next > 0
          && (
          <Link
            to={{ pathname: `/${this.props.competitionSlug}${this.state.path}/${this.state.next}/${this.state.nextSlug}` }}
            params={{ competitionSlug: this.props.competitionSlug }}
            className="preview-modal--next"
          >
            <Icon type="chevron-right" color="grey-dark" />
          </Link>
          )
          }

          <div className="row">
            <div className="col-9 preview-modal__image-gallery">
              {this.state.isLoaded ? (
                imagesList.map((image, index) => <img key={index} src={image.attributes.image.large.url} alt="" className="preview-modal__image" />)
              ) : (
                <div className="preview-modal__image-placeholder">
                  <Icon type={['fal', 'image']} color="grey-light" size="10x" />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="preview-modal-sidebar">
          <div className="row">
            <div className="col-3 offset-9">
              <section className="preview-modal-sidebar__content">
                <button className="btn btn-transparent overlay-modal--close-inner" onClick={() => this.props.history.push(`/${this.props.competitionSlug}${this.state.path}`)}>
                  <Icon type={['far', 'times']} color="grey-dark" />
                </button>

                {this.state.isLoaded ? (
                  <div className="preview-modal-sidebar__info">
                    <header>
                      <h2>{item.attributes.name}</h2>
                      <div className="author">{item.attributes.firstName} {item.attributes.lastName}</div>
                      <p>{item.attributes.description}</p>
                    </header>
                    <span className="published-date">Published: {moment(item.attributes.createdAt).format('YYYY.MM.DD HH:MM')}</span>
                    <div className="info-section">
                      <div className="row">
                        <div className="col">
                          <Icon type={['far', 'eye']} color="grey-dark" />
                          <span className="info-section__text">{item.attributes.views}</span>
                        </div>
                        <div className="col">
                          <Icon type="thumbs-up" color="grey-dark" />
                          <span className="info-section__text">{item.attributes.likesCount}</span>
                        </div>
                      </div>
                    </div>
                    <div className="button-container">
                      {App.config.userSignedIn ? (
                        <button className="btn btn-primary btn-block" onClick={this.like}>{item.attributes.likeState ? 'You like this' : 'Like'}</button>
                      ) : (
                        <Tooltip
                          className="like-tooltip"
                          tooltipClassName="tooltip--big tooltip--spaced"
                          id="top-keywords--tooltip"
                          content="You must be <a href='/users/login' target='_blank'>logged</a> in to like this"
                          event="click"
                          html
                        >
                          <button className="btn btn-primary btn-block">Like</button>
                        </Tooltip>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="preloading-content">
                    <Loader isFullHeight />
                  </div>
                )}
                <footer>
                  <SocialButtons
                    socialNetworks={['facebook', 'linkedin', 'twitter', 'pinterest']}
                    page="competition-artwork-preview"
                    share
                    url={window.location.href}
                  />
                </footer>
              </section>
            </div>
          </div>
        </div>
      </Modal>
    )
  }
}

ModalPreview.propTypes = {
  competitionSlug: PropTypes.string.isRequired,
  galleryOrder: PropTypes.array.isRequired,
  gallerySlugs: PropTypes.array.isRequired,
}

export default withRouter(ModalPreview)
